import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/winter-vacation-2023-homework/index.vue')
const Record = () => import('../activity/winter-vacation-2023-homework/RecordList.vue')
const Rank = () => import('../activity/winter-vacation-2023-homework/Rank/Rank.vue')

export const indexRoute: RouteConfig = {
  path: '/winter-vacation-2023-homework',
  name: 'winter_vacation_2023_homework',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '周周百分少年',
    ignoreLogin: true,
  },
}

export const recordRoute: RouteConfig = {
  path: '/winter-vacation-2023-homework-record',
  name: 'winter_vacation_2023_homework_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '周周百分少年',
    ignoreLogin: true,
  },
}

export const rankRoute: RouteConfig = {
  path: '/winter-vacation-2023-homework-rank',
  name: 'winter_vacation_2023_homework_rank',
  component: Rank,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '周周百分少年',
    ignoreLogin: true,
  },
}

export default [indexRoute, recordRoute, rankRoute]

export function navigateToWinterVacation2023Homework(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
